import { getRouteApi } from "@tanstack/react-router";

const guildRouteApi = getRouteApi("/dashboard/guilds/$applicationGuildId");

export function useGuildRoute() {
  const context = guildRouteApi.useRouteContext();
  const params = guildRouteApi.useParams();
  return { ...context, ...params };
}
